<style lang="scss" scoped>
.scope_status {
	.--bad:before {
		color: #dd536c;
		font-weight: bold;
	}

	.--normal:before {
		color: #87b3d2;
		font-weight: bold;
	}

	.--good:before {
		color: #56bd81;
		font-weight: bold;
	}
}
</style>

<template lang="pug">
.scopes
	page
		el-form.select-company-container(:inline='true')
			el-row.row-bg(type="flex", justify="space-between")
				el-col(:span="12")
					el-form-item(v-show="selectCompany", label='Select Company')
						company-search(v-model="companyId", :school="this.$attrs.school", @companiesFromSelection="handleCompaniesFromSelection")
				el-col(:span="12")
					el-button-group(style='float: right;')
						el-button(@click="filterScopes()" :type="filterType === 'all' ? 'primary': 'default'") All
						el-button(@click="filterScopes('approved')" :type="filterType === 'approved' ? 'primary': 'default'") Approved scopes only
						el-button(@click="filterScopes('optional')" :type="filterType === 'optional' ? 'primary': 'default'") Optional scopes only
	div(v-if="companyId")
		el-table(v-if="$apollo.loading || CompanySchoolScopes.length", v-loading="$apollo.loading", empty-text='No scopes found.', :data="CompanySchoolScopes" stripe)
			el-table-column(label='Name', property="nice_name" sortable)
				template(slot-scope="scope")
					span(style="display: inline-block; margin-right: 1em", class="scope_status")
						i(:class="scopeStatus(scope)")
					strong {{ scope.row.nice_name }} {{ scope.row.optional ? "(Optional)" : "" }}
			el-table-column(label='Requested At', property="created_at")
				template(slot-scope="scope")
					| {{ scope.row.created_at ? `${$options.filters.standard_datetime(scope.row.created_at)}` : "N/A"}}
			el-table-column(label='Active From', property="active_from_date")
				template(slot-scope="scope")
					| {{ scope.row.active_from_date ? `${$options.filters.standard_datetime(scope.row.active_from_date)}` : "N/A" }}
		page(v-else)
			empty No scopes found
</template>

<script>
import gql from 'graphql-tag';

export default {
	name: 'Scopes',
	data: () => ({
		CompanySchoolScopes: [],
		selectedScope: null,
		selectCompany: false,
		companyId: undefined,
		filterType: 'all',
	}),
	watch: {
		companyId: {
			handler() {
				this.$apollo.queries.CompanySchoolScopes.refetch();
			}
		},
	},
	methods: {
		handleCompaniesFromSelection(companies) {
			if (companies.length > 1) this.selectCompany = true;
		},
    scopeStatus(scope) {
      const { row } = scope;
      const declined = row.optional && row.active_from_date === null;
      const isCompanyWonde = this.companyId === 'A1329183376' || row.company_id === '1';

      if (declined) {
        return 'fe fe-x --bad';
      }

      if (row.company_scope_id === null || (!isCompanyWonde && row.can_be_activated)) {
        return 'fe fe-x-circle --bad';
      }

      if (row.can_be_activated && isCompanyWonde) {
        return 'fe fe-clock --normal';
      }

      return `fe fe-check ${!row.optional ? '--good' : '--normal'}`
    },
    async filterScopes(type = 'all') {
      await this.$apollo.queries.CompanySchoolScopes.refetch();
      this.filterType = type;

      if (type !== 'all') {
        this.CompanySchoolScopes = _.filter(this.CompanySchoolScopes, (scope) => {
          if (type === 'approved') {
            return scope.company_id !== null;
          }

          return scope.optional === true;
        });
      }
    }
	},
	apollo: {
		CompanySchoolScopes: {
			query: gql`
				query CompanySchoolScopes($company_id: String!, $school_id: String!) {
					CompanySchoolScopes(company_id: $company_id, school_id: $school_id) {
						id
						nice_name
						created_at
						active_from_date
						enabled
						optional
						can_be_activated
						company_id
						company_scope_id
					}
				}
			`,
			variables() {
				return {
					school_id: this.$route.params.school,
					company_id: this.$route.query.company_id || this.companyId
				};
			},
			skip() {
				return !this.companyId;
			}
		}
	}
};
</script>
